import { useAppSelector } from './use.redux';

export function useActiveVisit() {
  const state = useAppSelector((reducer) => reducer.userReducer.state);
  const activeVisit = state?.visit;
  return { activeVisitId: activeVisit?._id, activeVisit };
}
